import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-velux-reparatie"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Velux dakraam reparatie"
    />
  );
}